// extracted by css-extract-rspack-plugin
export default {"banner":"mBby9RV1hITY516H","warning":"gXfLHRGxEvIBkVz6"};